import _isNil from 'lodash/isNil';
import _property from 'lodash/property';

var id = _property('id');

var siteId = _property('siteId');

var isDefault = _property('defaultSite');

var name = _property('name');

var mainSite = _property('mainSite');

var dealerId = _property('dealerId');

var displayName = function displayName(siteDetails) {
  // if site name is present, return site name
  // if not return site - id.
  var siteName = name(siteDetails);
  if (!_isNil(siteName)) return siteName;
  var siteIdValue = siteId(siteDetails);
  return "".concat(__('site'), " - ").concat(siteIdValue);
};

var READER = {
  id: id,
  siteId: siteId,
  name: name,
  isDefault: isDefault,
  mainSite: mainSite,
  dealerId: dealerId,
  displayName: displayName
};
export default READER;